import { http } from "../api/http";
import Utils from "../utils";

export const mcpTokenService = {
  get,
  getById,
  getByClientId,
  create,
  update,
};

function get(requestParameters) {
  let url = `/mcptoken`;
  if (requestParameters && Object.keys(requestParameters).length > 0) {
    url += `?${Utils.objectToQueryString(requestParameters)}`;
  }
  return http.get(url).then((response) => response);
}

function getById(clientId) {
  let url = `/mcptoken/${clientId}`;
  return http.get(url).then((response) => response);
}

function getByClientId(clientId) {
  let url = `/mcptoken/client/${clientId}`;
  return http.get(url).then((response) => response);
}

function create(requestBody) {
  let url = `/mcptoken`;
  return http.post(url, JSON.stringify(requestBody)).then((response) => response);
}

function update(clientId, requestBody) {
  let url = `/mcptoken/${clientId}`;
  return http.put(url, JSON.stringify(requestBody)).then((response) => response);
}
